import JobModel from '@/common/models/jobs/job-model';

export default class BackendJobModel extends JobModel {
    hydrate(fields = {}) {
        super.hydrate(fields);
        const {
            externalId = null,
            status = null,
        } = fields;
        this.location = JobModel.Locations.backend;
        this.externalId = externalId;
        this.status = status;
    }

    getPayload() {
        return {
            ...super.getPayload(),
            externalId: this.externalId,
            status: this.status,
        };
    }
}
